module.exports = __webpack_public_path__ + "static/media/code.794e4b36.png";